import Component, { mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import WithRender from './FicheRepondantCard.html'

import {
  MButton,
  MButtonSkin,
  MDialog,
  MDialogWidth,
  MIcon,
  MMessage,
  MMessageState,
  MPanel
} from '@ulaval/modul-components'

import LocationSvg from '@/modules/global/media/svg/location/LocationSvg'
import { FICHE_REPONDANT_STATUT, IFicheRepondantModel } from '../FicheRepondant.model'
import FicheRepondantService from '../FicheRepondant.service'
import ROUTES from '@/router/ROUTES'

@WithRender
@Component({
  components: {
    LocationSvg,
    MButton,
    MDialog,
    MIcon,
    MMessage,
    MPanel
  }
})
export default class FicheRepondantCard extends mixins(FicheRepondantService) {
  private isDeleteLoadingStateActive: boolean = false
  private isDeleteConfirmationDialogDisplayed: boolean = false

  private readonly MButtonSkin: object = MButtonSkin
  private readonly MMessageState: object = MMessageState
  private readonly MDialogWidth: object = MDialogWidth
  
  @Prop({ required: true })
  private ficheRepondant!: IFicheRepondantModel

  private get computeStatutIcon(): string {
    switch (this.ficheRepondant.statut) {
      case FICHE_REPONDANT_STATUT.EN_ARRET:
        return 'm-svg__error'
      case FICHE_REPONDANT_STATUT.NON_CONFORME:
        return 'm-svg__warning'
      case FICHE_REPONDANT_STATUT.EN_TRAITEMENT:
        return 'm-svg__search'
      case FICHE_REPONDANT_STATUT.VALIDEE:
        return 'm-svg__confirmation'
      default:
        return 'm-svg__clock'
    }
  }

  private get panelClasses(): object {
    return {
      'fiche-repondant-card--updateable': this.ficheRepondant.isModifiableParEtudiant
    }
  }

  private deleteFicheRepondant(): void {
    this.isDeleteLoadingStateActive = true

    this.service_ficheRepondantService_delete(this.ficheRepondant.id)
      .finally(() => {
        this.isDeleteLoadingStateActive = false
        this.hideDeleteConfirmationDialog()
      })
  }

  private onPanelClick(): void {
    this.navigateToUpdatePage()
  }

  private onUpdateButtonClick(): void {
    this.navigateToUpdatePage()
  }

  private navigateToUpdatePage(): void {
    if (this.ficheRepondant.isModifiableParEtudiant) {
      this.mixin_router_navigate({
        name: ROUTES.FICHE_REPONDANT_UPDATE,
        params: {
          ...this.$route.params,
          idFicheRepondant: this.ficheRepondant.id
        },
        query: this.$route.query
      })
    }
  }

  private onDeleteButtonClick(): void {
    this.displayDeleteConfirmationDialog()
  }

  private displayDeleteConfirmationDialog(): void {
    this.isDeleteConfirmationDialogDisplayed = true
  }

  private hideDeleteConfirmationDialog(): void {
    this.isDeleteConfirmationDialogDisplayed = false
  }
}
